import { render, staticRenderFns } from "./WysiwygContainer.vue?vue&type=template&id=55cca545&"
import script from "./WysiwygContainer.vue?vue&type=script&lang=js&"
export * from "./WysiwygContainer.vue?vue&type=script&lang=js&"
import style0 from "./WysiwygContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports